// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

/* Create three equal columns that floats next to each other */
.column {
  float: left;
  width: 33.33%;
  padding: 10px;
  height: 300px; /* Should be removed. Only for demonstration */
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}

.centered-and-cropped {
  object-fit: cover;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  margin-left: 0px;
}

.mat-badge-content {
  background: #5ea1d8;
}

table {
  width: 100%;
}

.Login {
  background-color: white;
}

.banner {
  margin-top: 200px;
}

html {
  background-color: #56baed;
}

body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

a {
  color: #92badd;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
  color: #cccccc;
}

/* STRUCTURE */
.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

#formContent {
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 40px;
  width: 90%;
  max-width: 600px;
  overflow-y: hidden;
  width: 100%;
  position: relative;
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
  border: 0.5px solid lightgrey;
  height: calc(100vh - 80px);
  height: 100%;
}
#formContent::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}
#formContent::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
#formContent::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  border-radius: 0 0 10px 10px;
}

/* TABS */
h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #5fbae9;
}

/* FORM TYPOGRAPHY*/
input[type=button], input[type=submit], input[type=reset] {
  background-color: #56baed;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  transition: all 0.3s ease-in-out;
}

input[type=button]:hover, input[type=submit]:hover, input[type=reset]:hover {
  background-color: #39ace7;
}

input[type=button]:active, input[type=submit]:active, input[type=reset]:active {
  transform: scale(0.95);
}

input[type=text], input[type=password] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px 5px 5px 5px;
}

input[type=text]:focus, input[type=password]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

input[type=text]:placeholder, input[type=password] {
  color: #cccccc;
}

/* ANIMATIONS */
/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  animation-name: fadeInDown;
  animation-duration: 1s;
  animation-fill-mode: both;
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
/* Simple CSS3 Fade-in Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadeIn {
  opacity: 0;
  animation: fadeIn ease-in 1;
  animation-fill-mode: forwards;
  animation-duration: 1s;
}

.fadeIn.first {
  animation-delay: 0.4s;
}

.fadeIn.second {
  animation-delay: 0.6s;
  border: 0.5px solid lightgrey;
}

.fadeIn.third {
  animation-delay: 0.8s;
  border: 0.5px solid lightgrey;
}

.fadeIn.fourth {
  animation-delay: 1s;
  border: 0.5px solid lightgrey;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

.grid-container {
  display: grid;
  background-color: #2196F3;
  padding: 10px;
}

.grid-item {
  background-color: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(0, 0, 0, 0.8);
  padding: 20px;
  font-size: 30px;
  text-align: center;
}

.div1 {
  height: 50px;
  position: fixed;
  left: 0;
  width: 100%;
  background-color: white;
  overflow: inherit;
  bottom: 0;
}

.notify {
  color: grey;
}

.notify:hover {
  color: #5ea1d8;
}

.notify:active {
  color: #5ea1d8;
}

.notify:focus {
  color: #5ea1d8;
}

/*design starts here*/
#formContent {
  padding: 20px 40px;
  position: absolute;
  top: calc(50% + 10px);
  left: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid #ddd;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
}
#formContent p {
  font-size: 22px !important;
  line-height: 29px;
}

.cate-wrapper {
  display: flex;
  align-items: center;
  flex-flow: row wrap;
}
.cate-wrapper figure {
  flex-basis: 33.33%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  outline: none;
}
.cate-wrapper figure img {
  outline: none;
  border: 2px solid #fff;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
}
.cate-wrapper figcaption {
  font-family: "Raleway";
  margin-top: 10px;
  font-weight: 500;
  color: #212427 !important;
  font-size: 14px;
}

.web {
  min-height: calc(100vh - 80px);
  position: relative;
}

.Login {
  position: relative;
  background: #efeeee !important;
  display: block;
  width: 100%;
  height: 100vh;
}

.mobile {
  display: none !important;
}

@media only screen and (max-width: 1024px) and (min-width: 768px) {
  .Login {
    min-height: 90vh;
  }
}
@media only screen and (max-width: 767px) and (min-width: 320px) {
  .web {
    padding: 20px 0px 70px;
  }
  .Login {
    background: #fff !important;
  }
  #formContent {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    padding: 20px;
  }
  #formContent p {
    font-size: 17px !important;
  }
}
@media (max-width: 767px) {
  #formContent {
    width: calc(100% - 30px);
  }
}
@media (min-width: 1024px) {
  .cate-wrapper figure img {
    width: 100px !important;
    height: 100px !important;
  }
}
@media (max-width: 460px) {
  .cate-wrapper figure {
    flex-basis: 32.3%;
  }
  .cate-wrapper figure img {
    width: 60px !important;
    height: 60px !important;
  }
}
.foot-ico ul li {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.foot-ico ul li span {
  text-align: center;
  display: block;
  width: 100%;
  text-align: center;
}
.foot-ico ul li .icon-text {
  text-shadow: 0px 2px 2px rgba(186, 183, 183, 0.4);
  font-size: 12px;
  color: gray;
  display: block;
  text-align: center;
  font-family: "Raleway" !important;
}

:host-context(body.theme-dark) .Login {
  background-color: #0a0c10 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) #formContent {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  color: #e5e7eb !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/categories/categories.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;;AAEA,8DAAA;AACA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,aAAA,EAAA,8CAAA;AACF;;AAEA,mCAAA;AACA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AACF;;AACA;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAEF;;AAAA;EACE,mBAAA;AAGF;;AAAA;EACE,WAAA;AAGF;;AAOA;EAEE,uBAAA;AALF;;AAOA;EACA,iBAAA;AAJA;;AAMA;EACA,yBAAA;AAHA;;AAMA;EACA,kCAAA;EACA,aAAA;AAHA;;AAMA;EACA,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;AAHA;;AAMA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;AAHA;;AAQA,cAAA;AAEA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AANA;;AASA;EAEA,kCAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EAEA,kBAAA;EACA,WAAA;EACA,kBAAA;EAGA,4CAAA;EACA,kBAAA;EACA,6BAAA;EACA,0BAAA;EACA,YAAA;AARA;AAUA;EACE,UAAA;EACA,aAAA;AARF;AAUA;EACE,oDAAA;AARF;AAUA;EACE,yBAAA;EACA,0BAAA;AARF;;AAaA;EACA,yBAAA;EACA,6BAAA;EACA,aAAA;EACA,kBAAA;EAEA,4BAAA;AAVA;;AAeA,SAAA;AAEA;EACA,cAAA;AAbA;;AAgBA;EACA,cAAA;EACA,gCAAA;AAbA;;AAkBA,mBAAA;AAEA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;EAEA,iDAAA;EAEA,8BAAA;EACA,0BAAA;EAKA,gCAAA;AAhBA;;AAmBA;EACA,yBAAA;AAhBA;;AAmBA;EAKA,sBAAA;AAhBA;;AAmBA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EAKA,gCAAA;EAEA,8BAAA;AAhBA;;AAmBA;EACA,sBAAA;EACA,gCAAA;AAhBA;;AAmBA;EACA,cAAA;AAhBA;;AAqBA,eAAA;AAEA,uCAAA;AACA;EAEA,0BAAA;EAEA,sBAAA;EAEA,yBAAA;AAnBA;AAmCA;EACA;IACA,UAAA;IAEA,mCAAA;EApBE;EAsBF;IACA,UAAA;IAEA,eAAA;EApBE;AACF;AAuBA,kCAAA;AAGA;EAAoB;IAAO,UAAA;EALzB;EAKsC;IAAK,UAAA;EAF3C;AACF;AAGA;EACA,UAAA;EAGA,2BAAA;EAIA,6BAAA;EAIA,sBAAA;AAHA;;AAMA;EAGA,qBAAA;AAHA;;AAOA;EAGA,qBAAA;EACA,6BAAA;AAJA;;AAQA;EAGA,qBAAA;EACA,6BAAA;AALA;;AAQA;EAGA,mBAAA;EACA,6BAAA;AALA;;AAQA,kCAAA;AACA;EACA,cAAA;EACA,OAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;AALA;;AAQA;EACA,cAAA;AALA;;AAQA;EACA,WAAA;AALA;;AAYA;EACE,aAAA;EAEA,yBAAA;EACA,aAAA;AAVF;;AAYA;EACE,0CAAA;EACA,oCAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;AATF;;AAYA;EAEE,YAAA;EAEA,eAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;EACA,SAAA;AAXF;;AAoBA;EACE,WAAA;AAjBF;;AAmBA;EAEE,cAAA;AAjBF;;AAoBA;EAEE,cAAA;AAlBF;;AAqBA;EACE,cAAA;AAlBF;;AAuBA,qBAAA;AACA;EACE,kBAAA;EACA,kBAAA;EACE,qBAAA;EACA,SAAA;EACA,gCAAA;EACA,sBAAA;EACA,iDAAA;AApBJ;AAsBE;EACE,0BAAA;EACA,iBAAA;AApBJ;;AAuBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AApBF;AAqBE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;AAnBJ;AAoBI;EACE,aAAA;EACA,sBAAA;EACA,iDAAA;AAlBN;AAqBE;EACE,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;AAnBJ;;AAsBA;EACE,8BAAA;EACA,kBAAA;AAnBF;;AAqBA;EAEE,kBAAA;EACA,8BAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;AAnBF;;AAqBA;EACE,wBAAA;AAlBF;;AAoBA;EACE;IACE,gBAAA;EAjBF;AACF;AA2BA;EACE;IAEE,sBAAA;EA1BF;EA4BA;IACE,2BAAA;EA1BF;EA6BA;IACE,kBAAA;IACA,SAAA;IACA,UAAA;IACA,eAAA;IACA,aAAA;EA3BF;EA4BE;IACE,0BAAA;EA1BJ;AACF;AA8BA;EACA;IACI,wBAAA;EA5BF;AACF;AA8BA;EACE;IACE,uBAAA;IACA,wBAAA;EA5BF;AACF;AA8BA;EACE;IACE,iBAAA;EA5BF;EA6BE;IACE,sBAAA;IACA,uBAAA;EA3BJ;AACF;AA8BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AA5BF;AA6BE;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AA3BJ;AA6BE;EACE,iDAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EAEA,kBAAA;EACA,iCAAA;AA5BJ;;AAiCE;EACE,oCAAA;EACA,yBAAA;AA9BJ;AAiCE;EACE,8BAAA;EACA,iDAAA;EACA,yBAAA;AA/BJ","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\n/* Create three equal columns that floats next to each other */\n.column {\n  float: left;\n  width: 33.33%;\n  padding: 10px;\n  height: 300px; /* Should be removed. Only for demonstration */\n}\n\n/* Clear floats after the columns */\n.row:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.centered-and-cropped {\n  object-fit: cover;\n  border-radius:50%;\n  width: 80px;\n  height: 80px;\n  margin-left: 0px;\n}\n.mat-badge-content {\n  background:#5ea1d8;\n}\n\ntable {\n  width: 100%;\n}\n\n\n\n\n\n\n\n\n.Login{\n\n  background-color: white;\n}\n.banner{\nmargin-top:200px;\n}\nhtml {\nbackground-color: #56baed;\n}\n\nbody {\nfont-family: \"Poppins\", sans-serif;\nheight: 100vh;\n}\n\na {\ncolor: #92badd;\ndisplay:inline-block;\ntext-decoration: none;\nfont-weight: 400;\n}\n\nh2 {\ntext-align: center;\nfont-size: 16px;\nfont-weight: 600;\ntext-transform: uppercase;\ndisplay:inline-block;\nmargin: 40px 8px 10px 8px;\ncolor: #cccccc;\n}\n\n\n\n/* STRUCTURE */\n\n.wrapper {\ndisplay: flex;\nalign-items: center;\nflex-direction: column;\njustify-content: center;\nwidth: 100%;\nmin-height: 100%;\npadding: 20px;\n}\n\n#formContent {\n-webkit-border-radius: 10px 10px 10px 10px;\nborder-radius: 10px 10px 10px 10px;\nbackground: #fff;\npadding: 40px;\nwidth: 90%;\nmax-width: 600px;\n//max-height:530px;\noverflow-y:hidden;\nwidth:100%;\nposition: relative;\n// padding: 0px;\n-webkit-box-shadow: 0 30px 60px 0 rgba(0,0,0,0.3);\nbox-shadow: 0 30px 60px 0 rgba(0,0,0,0.3);\ntext-align: center;\nborder: 0.5px solid lightgrey;\nheight:calc(100vh - 80px);\nheight:100%;\n\n&::-webkit-scrollbar {\n  width: 4px;\n  height: 100px;\n}\n&::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n&::-webkit-scrollbar-thumb {\n  background-color: #5ea1d8;\n  outline: 1px solid #5ea1d8;\n}\n\n}\n\n#formFooter {\nbackground-color: #f6f6f6;\nborder-top: 1px solid #dce8f1;\npadding: 25px;\ntext-align: center;\n-webkit-border-radius: 0 0 10px 10px;\nborder-radius: 0 0 10px 10px;\n}\n\n\n\n/* TABS */\n\nh2.inactive {\ncolor: #cccccc;\n}\n\nh2.active {\ncolor: #0d0d0d;\nborder-bottom: 2px solid #5fbae9;\n}\n\n\n\n/* FORM TYPOGRAPHY*/\n\ninput[type=button], input[type=submit], input[type=reset]  {\nbackground-color: #56baed;\nborder: none;\ncolor: white;\npadding: 15px 80px;\ntext-align: center;\ntext-decoration: none;\ndisplay: inline-block;\ntext-transform: uppercase;\nfont-size: 13px;\n-webkit-box-shadow: 0 10px 30px 0 rgba(95,186,233,0.4);\nbox-shadow: 0 10px 30px 0 rgba(95,186,233,0.4);\n-webkit-border-radius: 5px 5px 5px 5px;\nborder-radius: 5px 5px 5px 5px;\nmargin: 5px 20px 40px 20px;\n-webkit-transition: all 0.3s ease-in-out;\n-moz-transition: all 0.3s ease-in-out;\n-ms-transition: all 0.3s ease-in-out;\n-o-transition: all 0.3s ease-in-out;\ntransition: all 0.3s ease-in-out;\n}\n\ninput[type=button]:hover, input[type=submit]:hover, input[type=reset]:hover{\nbackground-color: #39ace7;\n}\n\ninput[type=button]:active, input[type=submit]:active, input[type=reset]:active  {\n-moz-transform: scale(0.95);\n-webkit-transform: scale(0.95);\n-o-transform: scale(0.95);\n-ms-transform: scale(0.95);\ntransform: scale(0.95);\n}\n\ninput[type=text],input[type=password] {\nbackground-color: #f6f6f6;\nborder: none;\ncolor: #0d0d0d;\npadding: 15px 32px;\ntext-align: center;\ntext-decoration: none;\ndisplay: inline-block;\nfont-size: 16px;\nmargin: 5px;\nwidth: 85%;\nborder: 2px solid #f6f6f6;\n-webkit-transition: all 0.5s ease-in-out;\n-moz-transition: all 0.5s ease-in-out;\n-ms-transition: all 0.5s ease-in-out;\n-o-transition: all 0.5s ease-in-out;\ntransition: all 0.5s ease-in-out;\n-webkit-border-radius: 5px 5px 5px 5px;\nborder-radius: 5px 5px 5px 5px;\n}\n\ninput[type=text]:focus, input[type=password]:focus {\nbackground-color: #fff;\nborder-bottom: 2px solid #5fbae9;\n}\n\ninput[type=text]:placeholder, input[type=password] {\ncolor: #cccccc;\n}\n\n\n\n/* ANIMATIONS */\n\n/* Simple CSS3 Fade-in-down Animation */\n.fadeInDown {\n-webkit-animation-name: fadeInDown;\nanimation-name: fadeInDown;\n-webkit-animation-duration: 1s;\nanimation-duration: 1s;\n-webkit-animation-fill-mode: both;\nanimation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeInDown {\n0% {\nopacity: 0;\n-webkit-transform: translate3d(0, -100%, 0);\ntransform: translate3d(0, -100%, 0);\n}\n100% {\nopacity: 1;\n-webkit-transform: none;\ntransform: none;\n}\n}\n\n@keyframes fadeInDown {\n0% {\nopacity: 0;\n-webkit-transform: translate3d(0, -100%, 0);\ntransform: translate3d(0, -100%, 0);\n}\n100% {\nopacity: 1;\n-webkit-transform: none;\ntransform: none;\n}\n}\n\n/* Simple CSS3 Fade-in Animation */\n@-webkit-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }\n@-moz-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }\n@keyframes fadeIn { from { opacity:0; } to { opacity:1; } }\n\n.fadeIn {\nopacity:0;\n-webkit-animation:fadeIn ease-in 1;\n-moz-animation:fadeIn ease-in 1;\nanimation:fadeIn ease-in 1;\n\n-webkit-animation-fill-mode:forwards;\n-moz-animation-fill-mode:forwards;\nanimation-fill-mode:forwards;\n\n-webkit-animation-duration:1s;\n-moz-animation-duration:1s;\nanimation-duration:1s;\n}\n\n.fadeIn.first {\n-webkit-animation-delay: 0.4s;\n-moz-animation-delay: 0.4s;\nanimation-delay: 0.4s;\n\n}\n\n.fadeIn.second {\n-webkit-animation-delay: 0.6s;\n-moz-animation-delay: 0.6s;\nanimation-delay: 0.6s;\nborder: 0.5px solid lightgrey;\n}\n\n\n.fadeIn.third {\n-webkit-animation-delay: 0.8s;\n-moz-animation-delay: 0.8s;\nanimation-delay: 0.8s;\nborder: 0.5px solid lightgrey;\n}\n\n.fadeIn.fourth {\n-webkit-animation-delay: 1s;\n-moz-animation-delay: 1s;\nanimation-delay: 1s;\nborder: 0.5px solid lightgrey;\n}\n\n/* Simple CSS3 Fade-in Animation */\n.underlineHover:after {\ndisplay: block;\nleft: 0;\nbottom: -10px;\nwidth: 0;\nheight: 2px;\nbackground-color: #56baed;\ncontent: \"\";\ntransition: width 0.2s;\n}\n\n.underlineHover:hover {\ncolor: #0d0d0d;\n}\n\n.underlineHover:hover:after{\nwidth: 100%;\n}\n\n\n\n\n\n.grid-container {\n  display: grid;\n  //grid-template-columns: auto auto auto;\n  background-color: #2196F3;\n  padding: 10px;\n}\n.grid-item {\n  background-color: rgba(255, 255, 255, 0.8);\n  border: 1px solid rgba(0, 0, 0, 0.8);\n  padding: 20px;\n  font-size: 30px;\n  text-align: center;\n}\n\n.div1 {\n\n  height: 50px;\n  //border: 1px solid blue;\n  position: fixed;\n  left: 0;\n  width: 100%;\n  background-color:white;\n  overflow: inherit;\n  bottom: 0;\n}\n\n\nmat-grid-tile {\n // background: lightblue;\n}\n\n\n.notify{\n  color: grey;\n}\n.notify:hover{\n\n  color: #5ea1d8;\n\n}\n.notify:active{\n\n  color: #5ea1d8;\n\n}\n.notify:focus{\n  color: #5ea1d8;\n}\n\n\n\n/*design starts here*/\n#formContent{\n  padding:20px 40px;\n  position: absolute;\n    top: calc(50% + 10px);\n    left: 50%;\n    transform: translate(-50%, -50%);\n    border:1px solid #ddd;\n    box-shadow:-2px 2px 7px rgb(200 193 193 / 50%);\n    // max-height:70vh;\n  p{\n    font-size:22px !important;\n    line-height:29px;\n  }\n}\n.cate-wrapper{\n  display:flex;\n  align-items: center;\n  flex-flow: row wrap;\n  figure{\n    flex-basis:33.33%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    outline:none;\n    img{\n      outline:none;\n      border:2px solid #fff;\n      box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n    }\n  }\n  figcaption{\n    font-family: \"Raleway\";\n    margin-top:10px;\n    font-weight:500;\n    color:#212427 !important;\n    font-size:14px;\n  }\n}\n.web{\n  min-height:calc(100vh - 80px);\n  position: relative;\n}\n.Login{\n  //  min-height:calc(100vh - 80px);\n  position:relative;\n  background:#efeeee !important;\n  display: block;\n  width:100%;\n  height: 100vh;\n}\n.mobile{\n  display:none !important;\n}\n@media only screen and (max-width: 1024px) and (min-width: 768px){\n  .Login{\n    min-height: 90vh;\n\n  }\n  // #formContent{\n  //   position: relative;\n  //   top:auto;\n  //   left:auto;\n  //   transform: none;\n  // }\n}\n\n@media only screen and (max-width: 767px) and (min-width: 320px){\n  .web{\n\n    padding:20px 0px 70px;\n  }\n  .Login{\n    background: #fff !important;\n\n  }\n  #formContent{\n    position: relative;\n    top:auto;\n    left:auto;\n    transform: none;\n    padding:20px;\n    p{\n      font-size:17px !important;\n    }\n  }\n\n}\n@media (max-width: 767px){\n#formContent {\n    width: calc(100% - 30px);\n}\n}\n@media(min-width:1024px){\n  .cate-wrapper figure img{\n    width:100px !important;\n    height:100px !important;\n  }\n}\n@media(max-width:460px){\n  .cate-wrapper figure{\n    flex-basis:32.3%;\n    img{\n      width:60px !important;\n      height:60px !important;\n    }\n  }\n}\n.foot-ico ul li{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  span{\n    text-align: center;\n    display: block;\n    width: 100%;\n    text-align: center;\n  }\n  .icon-text{\n    text-shadow: 0px 2px 2px rgba(186, 183, 183, 0.4);\n    font-size: 12px;\n    color: gray;\n    display: block;\n    // width: 80px;\n    text-align: center;\n    font-family: \"Raleway\" !important;\n  }\n}\n\n:host-context(body.theme-dark) {\n  .Login {\n    background-color: #0a0c10 !important;\n    color: #e5e7eb !important;\n  }\n\n  #formContent {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n    color: #e5e7eb !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
